import { useCallback } from "react";
import { EQM2070DetailTabType, useEQM2070_R01Store } from "./Store_EQM2070_R01";
import { EQM2070_R01_DETAIL_TABS } from "./utils/tabConfig";

export const TableTab_EQM2070_R01 = () => {
	const {
		EQM2070_R01Filter,
		initSelectedEQM2070_R01,
		setEQM2070_R01Filter,
	} = useEQM2070_R01Store();
	const activeDetailTab = EQM2070_R01Filter.equipmentCd as EQM2070DetailTabType;

	const handleEQM2070_R01DetailTabClick = useCallback((tab: EQM2070DetailTabType) => {
		if (tab === activeDetailTab) return;

		initSelectedEQM2070_R01();
		setEQM2070_R01Filter({ equipmentCd: tab, equipmentNm: "" });
	}, [activeDetailTab, initSelectedEQM2070_R01, setEQM2070_R01Filter]);

	return (
		<div
			className="flex items-end mb-[0.1px] bg-white h-[25px]"
			role="tablist"
			aria-label="도금라인 점검 탭"
		>
			{EQM2070_R01_DETAIL_TABS.map((tab) => {
				const isActive = activeDetailTab === tab.id;
				return (
					<button
						key={tab.id}
						type="button"
						onClick={() => handleEQM2070_R01DetailTabClick(tab.id)}
						role="tab"
						aria-selected={isActive}
						className={`h-[26px] px-3 text-[12px] font-medium transition-colors border border-gray-300 border-b-0
							${isActive
								? "bg-white text-black-700 -mb-px shadow-sm"
								: "bg-gray-100 text-gray-700 hover:bg-gray-200"}
						`}
					>
						{tab.label}
					</button>
				);
			})}
		</div>
	);
};
